/*
 * @Author: jean
 * @LastEditors: jean
 * @Description:
 * @Date: 2021-12-8 14:53:23
 * @LastEditTime: 2021-02-09 08:36:14
 */
import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 提交评论
  static commitCommet(params) {
    return request({
      url: `tradecore/evaluate/add`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
  static getComment(tradeNo, type) {
    return request({
      url: `tradecore/evaluate/evaluateInfo?tradeNo=${tradeNo}&type=${type}`
      // method: 'post',
    });
  }
  static submit(params) {
    return request({
      url: `experience/add`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/Comment/CommentServ.js